import React, {PureComponent} from "react"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {User, Reward, RewardOrder} from "@irati/types"
import {WhoRewardedRewardTypes, WhoRewardedVisibilityTypes, WhoRewardedTypes} from "@irati/reward/enums/WhoRewardedTypes"
import {getRewardDescription, getRewardText, getUserText} from "@irati/reward/utils/whoRewarded/textHelpers"
import {getVisibilityType, getRewardType, getUserType} from "@irati/reward/utils/whoRewarded/typeHelpers"
import {DisplayIconWrapper, DescriptionWrapper} from "./styled"
import DisplayIcon from "./DisplayIcon"
import DisplayDescription from "./DisplayDescription"

interface Props extends InjectIntl {
  reward: Reward
  rewardOrder: RewardOrder
  user: User
}

class WhoRewarded extends PureComponent<Props> {
  render() {
    const {reward, rewardOrder, intl} = this.props
    const {formatMessage} = intl

    const visibilityType = getVisibilityType()
    const userType = getUserType(rewardOrder)
    const rewardType = getRewardType(reward, rewardOrder)

    const isHidden = visibilityType === WhoRewardedVisibilityTypes.HIDDEN
    const isViewer = userType === WhoRewardedTypes.VIEWER
    const isLimited = visibilityType === WhoRewardedVisibilityTypes.LIMITED

    if (rewardType === WhoRewardedRewardTypes.NO_REWARD) return null
    if (isHidden && isViewer) return null

    const rewardDescription = getRewardDescription(reward, rewardOrder, rewardType)
    const rewardText = getRewardText(rewardType, formatMessage)
    const userText = getUserText(formatMessage, userType, rewardOrder.createdBy)
    return (
      <>
        <DisplayIconWrapper>
          <DisplayIcon rewardType={rewardType} />
        </DisplayIconWrapper>
        <DescriptionWrapper>
          {isLimited && isViewer ? (
            rewardText
          ) : (
            <DisplayDescription costPerUnit={rewardDescription.costPerUnit} text={rewardDescription.text} />
          )}
        </DescriptionWrapper>
        <span>{` ${userText}`}</span>
      </>
    )
  }
}

export default injectIntl(WhoRewarded)
